import type { ChatRoomState, ChatRoomUIState } from "./types";

export const initialChatRoomUiState: ChatRoomUIState = {
  isLoading: false,
  hasNextPage: false,
  hasPrevPage: false,
  scrollInfo: {},
  firstMessageId: null,
  lastMessageId: null,
  shouldShowLatestMessageBtn: false,
  topMessageId: null,
  isInitialPageLoaded: false,
  activeMessageId: null,
};

export const initialChatRoomState: ChatRoomState = {
  uiState: initialChatRoomUiState,
  chatRoomMessages: [],
};

export const MAX_MESSAGES_THRESHOLD = 60;
export const MESSAGES_THRESHOLD = 40;
